import SETTINGS from '@/src/settings'

const SITE_DOMAINS = {
  COS: ['lacentralecos', 'staging.pharmeditest.com'],
  LES_OFFICINALES: ['officap'],
  GCAP_PHARMA: ['gcap-pharma'],
  CENTRALE_MEDIPRIX: ['lacentralemediprix'],
  PHARMACOLOGY_STORE: ['pharmacologystore'],
  CENTRALE_DPHARMA: ['lacentraledpharma'],
  AELIA_STORE: ['aelia'],
  OUTRE_MER: ['outremer', 'techexmachina'], //@todo store.techexmachina.com for test local
  HELLO_PHARMACIE: ['lacentralehellopharmacie'],
  NORMANDIE_PHARMA: ['lacentralenormandiepharma'],
  TRENTE_SEPT_DEGRES: ['37degres-macentrale'],
}

const domainIncludes = (domain: string | null, patterns: string[]): boolean => {
  if (!domain) return false
  return patterns.some(pattern => domain.includes(pattern))
}

export const urlSiteGroupement = (host = null) => {
  const url = typeof window !== 'undefined' ? new URL(window.location.href) : null
  const urlDetect = host || url?.host

  const siteCos = domainIncludes(urlDetect, SITE_DOMAINS.COS)
  const siteLesOfficinales = domainIncludes(urlDetect, SITE_DOMAINS.LES_OFFICINALES)
  const siteGcapPharma = domainIncludes(urlDetect, SITE_DOMAINS.GCAP_PHARMA)
  const siteCentraleMediprix = domainIncludes(urlDetect, SITE_DOMAINS.CENTRALE_MEDIPRIX)
  const sitePharmacologyStore = domainIncludes(urlDetect, SITE_DOMAINS.PHARMACOLOGY_STORE)
  const siteCentraleDpharma = domainIncludes(urlDetect, SITE_DOMAINS.CENTRALE_DPHARMA)
  const siteAeliaStore = domainIncludes(urlDetect, SITE_DOMAINS.AELIA_STORE)
  const siteOutremer = domainIncludes(urlDetect, SITE_DOMAINS.OUTRE_MER)
  const siteHelloPharmacie = domainIncludes(urlDetect, SITE_DOMAINS.HELLO_PHARMACIE)
  const siteNormandiePharma = domainIncludes(urlDetect, SITE_DOMAINS.NORMANDIE_PHARMA)
  const site37Degres = domainIncludes(urlDetect, SITE_DOMAINS.TRENTE_SEPT_DEGRES)

  return {
    siteCos,
    siteLesOfficinales,
    siteGcapPharma,
    siteCentraleMediprix,
    sitePharmacologyStore,
    siteCentraleDpharma,
    siteAeliaStore,
    siteOutremer,
    siteHelloPharmacie,
    siteNormandiePharma,
    site37Degres,
    storefrontId: getStorefrontId({
      siteCos,
      siteAeliaStore,
      siteLesOfficinales,
      siteGcapPharma,
      siteCentraleMediprix,
      sitePharmacologyStore,
      siteCentraleDpharma,
      siteOutremer,
      siteHelloPharmacie,
      siteNormandiePharma,
      site37Degres,
    }), // @todo gestion dynamic des storefront for @see callCsCartApi.ts
  }
}

const getStorefrontId = ({
  siteCos,
  siteAeliaStore,
  siteLesOfficinales,
  siteGcapPharma,
  siteCentraleMediprix,
  sitePharmacologyStore,
  siteCentraleDpharma,
  siteOutremer,
  siteHelloPharmacie,
  siteNormandiePharma,
  site37Degres,
}) => {
  if (siteAeliaStore) {
    return SETTINGS.storefrontAelia
  } else if (siteLesOfficinales) {
    return SETTINGS.storefrontLesOfficinales
  } else if (siteGcapPharma) {
    return SETTINGS.storefrontGcapPharma
  } else if (siteCentraleMediprix) {
    return SETTINGS.storefrontCentraleMediprix
  } else if (sitePharmacologyStore) {
    return SETTINGS.storefrontPharmacologyStore
  } else if (siteCentraleDpharma) {
    return SETTINGS.storefrontCentraleDpharma
  } else if (siteCos) {
    return SETTINGS.storefrontCos
  } else if (siteOutremer) {
    return SETTINGS.storefrontOutreMer
  } else if (siteHelloPharmacie) {
    return SETTINGS.storefrontHelloPharmacie
  } else if (siteNormandiePharma) {
    return SETTINGS.storefrontNormandiePharma
  } else if (site37Degres) {
    return SETTINGS.storefront37Degres
  } else {
    return SETTINGS.storefrontDefault
  }
}
